<app-bookupp-header *ngIf="parking?.parkingType == ParkingType.BOOKING"></app-bookupp-header>
<app-header *ngIf="parking?.parkingType != ParkingType.BOOKING"></app-header>

<div *ngIf="!parking; else parkingContent" class="page-loading-icon">
    <i class="fas fa-spinner fa-spin"></i>
</div>

<ng-template #parkingContent>
    <ng-container>
        <ng-container *ngIf="parking.parkingType == ParkingType.BOOKING; else defaultTemplate">
            <app-parking-page-bookupp></app-parking-page-bookupp>
        </ng-container>

        <ng-template #defaultTemplate>
            <app-parking-page-classic></app-parking-page-classic>
        </ng-template>
    </ng-container>

    <app-footer *ngIf="!globalService.whitelabeled && parking?.parkingType != ParkingType.BOOKING"></app-footer>
    <app-bookupp-footer *ngIf="!globalService.whitelabeled && parking?.parkingType == ParkingType.BOOKING"></app-bookupp-footer>
    <app-footer-whitelabel *ngIf="globalService.whitelabeled"></app-footer-whitelabel>
</ng-template>
